import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { WomanAvatar, ManAvatar } from '../../static/svg/worker-avatars'
import verifiedIcon from '../../static/img/ic-verified.png'

class WorkerContainer extends Component {

	render() {
		let { t } = this.context

		return (
			<div className="WorkerContainer">
				{this.renderWorkerAvatar(true)}
				<div className="worker-details">
					<div className="name">{t('booking_flow_date_selection_worker_label', { worker_name: this.props.worker.firstName })}</div>
					<div className="affiliate">{this.props.worker.affiliateName}</div>
				</div>
				{this.props.onShowOtherWorkersClick &&
				<div className="choose-other-worker-container">
					<div className="title"
						 onClick={this.props.onShowOtherWorkersClick}>{t('booking_flow_date_selection_choose_another_worker')}</div>
				</div>}
			</div>
		)
	}

	renderWorkerAvatar = () => {
		return (
			<div className="worker-avatar">
				{this.props.worker.title === 'mr' ? <ManAvatar isSelected={false} /> : <WomanAvatar isSelected={false} />}
				{this.props.displayVerifiedIcon && <img className="verified-icon" alt="" src={verifiedIcon}/>}
			</div>
		)
	}
}

WorkerContainer.contextTypes = { t: PropTypes.func }
export default WorkerContainer


// WEBPACK FOOTER //
// ./src/components/bookingflow/WorkerContainer.js